"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const queries = [{
  question: "How long does a trademark transfer take under the Trade Marks Act, 1999?",
  answer: "While official registry updates under the Trade Marks Act, 1999 can take several months, our streamlined legal coordination ensures that the Deed of Assignment is executed within 2 to 4 weeks. This allows you to legally begin using the brand almost immediately after the transaction is finalized."
}, {
  question: "Are there any upfront listing fees to sell my registered trademark?",
  answer: "No, Business Tantra does not charge any upfront listing fees. We operate on a success-based model for trademark monetization, meaning our advisory and placement fees are only applicable once your trademark is successfully acquired by a verified buyer."
}, {
  question: "What legal documentation is involved in the acquisition process?",
  answer: "We handle all necessary documentation required by the Trade Marks Act, 1999. This includes drafting the Deed of Assignment, securing No Objection Certificates (NOCs), and filing the TM-P form with the Trademark Registry to ensure a compliant and secure transfer of ownership."
}, {
  question: "Can I acquire a trademark that spans multiple business categories?",
  answer: "Yes. Our curated portfolio includes multi-class brand assets designed for broad expansion. If a trademark is registered across multiple classes (e.g., FMCG and natural wellness), the acquisition can be structured to transfer rights across all applicable categories."
}, {
  question: "How do you ensure the trademarks are legally vetted and safe to buy?",
  answer: "Every trademark in our catalogue undergoes a rigorous due diligence process. We verify the registration status, check for any pending litigations or oppositions, and ensure the seller has clear, unencumbered rights to transfer the asset before listing it."
}];
export default function CommonQueries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="common-queries" className="bg-background py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground font-sans tracking-tight">
            Common Queries
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Clear answers regarding legal compliance, timelines, and our process.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {queries.map((query, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
              <AccordionTrigger className="[&>svg:last-child]:hidden [&[data-state=open]_.custom-icon]:rotate-45 hover:no-underline py-5 text-base md:text-lg font-semibold text-foreground group">
                <span className="text-left pr-4">{query.question}</span>
                <Plus className="size-5 shrink-0 text-primary transition-transform duration-300 custom-icon" />
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 pr-8">
                {query.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}